/**
 * Single product functionality.
 */
import imagesLoaded from 'imagesloaded';
import 'flickity/css/flickity.css';
import Flickity from 'flickity';
import stickybits from 'stickybits';

// flickity-as-nav-for is added as a require because for some dumb reason the build process on synotio wont work otherwise.
require( 'flickity-as-nav-for' );

jQuery( $ => {
	const $body = $( 'body' );

	/**
	 * Generates an array of objects containing image element and variation attributes
	 *
	 * @param {Array} collection An array of image elements.
	 * @return {Array} An array of objects,
	 */
	function generateList( collection ) {
		const collectionList = new Array();
		collection.forEach( image => {
			collectionList.push( {
				element: image,
				attributes: JSON.parse( image.dataset.attributes ),
			} );
		} );
		return collectionList;
	}

	// Setup a list of images.
	const images = document.querySelectorAll( '.product-image-slider-item' );
	const imageList = generateList( images );

	// Setup a list of thumbs.
	const thumbs = document.querySelectorAll( '.product-images-slider-item-thumb' );
	const thumbList = generateList( thumbs );

	/**
	 * Initializes the flickity sliders.
	 */
	function initFlickity() {
		$( '.product-images-slider-container' ).each( function() {
			new imagesLoaded( this, { background: true }, () => {
				const slider = $( '.product-image-slider', this )[ 0 ];

				new Flickity( slider, {
					prevNextButtons: false,
					dragThreshold: 10,
					on: {
						ready() {
							const sliderInstance = this;
							// When a variation is found change the images in the slider
							$( '.variations_form' ).on( 'found_variation', function( event, variation ) {
								filterSlider( variation, sliderInstance, imageList );
							} );
							// If a variation is reset change the images back to default in the slider.
							$( '.variations_form' ).on( 'reset_data', function() {
								resetSlider( sliderInstance, imageList );
							} );
						},
					},
				} ).resize();

				// Setup the thumbnails navigation.
				const productThumbnailsOptions = {
					asNavFor: slider,
					pageDots: false,
					draggable: false,
					percentPosition: false,
					groupCells: true,
					cellAlign: 'left',
					prevNextButtons: false,
					on: {
						ready() {
							const sliderInstance = this;
							// When a variation is found change the images in the slider
							$( '.variations_form' ).on( 'found_variation', function( event, variation ) {
								filterSlider( variation, sliderInstance, thumbList );
							} );
							// If a variation is reset change the images back to default in the slider.
							$( '.variations_form' ).on( 'reset_data', function() {
								resetSlider( sliderInstance, thumbList );
							} );
						},
					},
				};

				// If there's more than 6 thumbnails we need navigation!
				if ( 6 < $( '.product-images-slider-thumbnails-slide .product-images-slider-item-thumb', this ).length ) {
					productThumbnailsOptions.prevNextButtons = true;
				}

				new Flickity( $( '.product-images-slider-thumbnails-slide', this )[ 0 ], productThumbnailsOptions );
			} );
		} );
	}

	/**
	 * Filters out images in the product image slider and thumbnail slider based on the selected variation.
	 *
	 * @param {Object} variation the variation chosen
	 * @param {Object} slider a flickity slider object
	 * @param {Array} list a list of objects containing image element and attributes connected to it.
	 */
	function filterSlider( variation, slider, list ) {
		// Remove all from slider.
		slider.remove( slider.getCellElements() );

		// Find which images has same attributes as the selected variation.
		// We use a little JS trick here where we convert both objects to strings and compare those.
		const appendImages = [];
		list.forEach( image => {
			if ( JSON.stringify( image.attributes ) === JSON.stringify( variation.attributes ) ) {
				appendImages.push( image.element );
			}
		} );
		// Add to slider, reload the cells and select the first one.
		slider.append( appendImages );
		slider.reloadCells();
		slider.select( 0, true, true );
		slider.resize();
		// If there's more than 6 thumbnails we need navigation!
		if ( $( '.product-images-slider-thumbnails-slide .product-images-slider-item-thumb' ).length < 6 ) {
			$( 'button.flickity-prev-next-button.previous, button.flickity-prev-next-button.next' ).hide();
		} else {
			$( 'button.flickity-prev-next-button.previous, button.flickity-prev-next-button.next' ).show();
		}
	}

	/**
	 * Resets the slider content back to all images when variations are deselected.
	 *
	 * @param {Object} slider a flickity slider object
	 * @param {Array} list the list of image objects
	 */
	function resetSlider( slider, list ) {
		const appendImages = [];
		list.forEach( image => {
			appendImages.push( image.element );
		} );
		// Add to slider, reload the cells and select the first one.
		slider.append( appendImages );
		slider.reloadCells();
		slider.select( 0, true, true );
		// If these element exists that means they were relevant when all images are showing.. ie lets show them.
		$( 'button.flickity-prev-next-button.previous, button.flickity-prev-next-button.next' ).show();
	}

	/**
	 * Single product images as a slider.
	 */
	initFlickity();

	/**
	 * Set up an initial trigger for any products that have default variations set.
	 * Since we have a bit of a race between the variations forms found_variation and flickitys ready state we can't trust that the initial images is set correctly
	 * when there's a default variation set for the product.
	 */
	$( '.variations_form' ).one( 'found_variation', function( event, variation ) { // eslint-disable-line
		// Needs a short timeout so the flickity elements are created first, it's hard to get around this I'm afraid.
		setTimeout(
			() => {
				const mainSlider = Flickity.data( '.product-image-slider' );
				const thumbSlider = Flickity.data( '.product-images-slider-thumbnails-slide' );
				if ( mainSlider ) {
					filterSlider( variation, mainSlider, imageList );
				}
				if ( thumbSlider ) {
					filterSlider( variation, thumbSlider, thumbList );
				}
			},
			400
		);
	} );

	/**
	 * Summary as a sticky container on scroll.
	 * Source: https://github.com/dollarshaveclub/stickybits
	 */
	stickybits( '.product .entry-summary', {
		useStickyClasses: true,
	} );

	/**
	 * Trigger accordion.
	 */
	$( '.product-block-content > h2' ).on( 'click', function() {
		const $parentEl = $( this ).closest( '.product-block' );
		toggleProductBlock( $parentEl );
	} );

	/**
	 * Toggle the description block
	 */
	$body.on( 'click', '.product-meta-link-info a', function() {
		const target = $( this ).attr( 'href' );
		if ( '#' !== target.charAt( 0 ) ) {
			return;
		}
		toggleProductBlock( $( target ), true );
	} );

	/**
	 * Make changes to the page whenever a change in the variations occurs.
	 * Show variation selection along with the label.
	 * Show the variations price instead of the price range.
	 *
	 */
	$body.on( 'change', '.variations select', function() {
		setTimeout( setVariationPricing, 200 );
	} ).trigger( 'change' );

	/**
	 * Toggles a product blocks accordion.
	 *
	 * @param {Object} blockEl the outer block element.
	 * @param {boolean} forceOpen wether it should be forced to open.
	 */
	function toggleProductBlock( blockEl, forceOpen = false ) {
		const trigger = blockEl.find( 'h2' );
		const content = blockEl.find( '.product-block-inner-content' );

		if ( forceOpen ) {
			blockEl.removeClass( 'accordion-hidden' );
			trigger.attr( 'aria-expanded', 'true' );
			content.attr( 'aria-hidden', 'false' );
			return;
		}
		// Toggle class for the block which sets visibility.
		blockEl.toggleClass( 'accordion-hidden' );
		// Aria for the h2 trigger element.
		trigger.attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
		// Aria for the hidden content.
		content.attr( 'aria-hidden', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
	}

	// Save the original product price html so it can be reset.
	const originalPrice = $( '.summary-inner-wrapper > .price' ).html();

	/**
	 * Changes the price displayed to that of the chosen variation.
	 */
	function setVariationPricing() {
		const variationId = $( 'input[name="variation_id"]' ).val();
		let $priceEl = $( '.summary-inner-wrapper > .price' );

		if ( ! $priceEl.length ) {
			$priceEl = $( '.qala-quickview-product-container__right .price' );
		}

		// No variation selected means we want to reset the product price html and bail.
		if ( undefined === variationId || 0 === parseInt( variationId ) || '' === variationId ) {
			$priceEl.html( originalPrice );
			return;
		}

		// Get the variation price and overwrite the range pricing html.
		const variationPrice = $( '.woocommerce-variation-price .price' ).html();
		$priceEl.html( variationPrice );
	}

	// Quickview Support for Flickity galleries and variable products.
	jQuery( 'body' ).on( 'quickview-loaded', () => {
		// Initialize filickity
		initFlickity();

		// Initialize the variations checkout script
		jQuery( '#qala-quickview-content .variations_form' ).wc_variation_form();
	} );
} );
